// src/App.js
import React, { useEffect, useState } from "react";

function App() {
  const [list, setList] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/api.php?action=list");
      const j = await res.json();
      if (j.ok) setList(j.data);
      else console.error(j);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const res = await fetch("/api/api.php?action=add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: text.trim() }),
      });
      const j = await res.json();
      if (j.ok) {
        setText("");
        fetchList();
      } else {
        alert("Error: " + (j.error || "unknown"));
      }
    } catch (err) {
      alert("Network error: " + err.message);
    }
  };

  return (
    <div style={{ maxWidth: 700, margin: "40px auto", fontFamily: "Arial, sans-serif" }}>
      <h1>Hostinger test: React + PHP + MySQL</h1>

      <form onSubmit={handleSubmit} style={{ marginBottom: 20 }}>
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Write something to save"
          style={{ padding: "8px 10px", width: "70%", marginRight: 8 }}
        />
        <button type="submit" style={{ padding: "8px 12px" }}>
          Add
        </button>
      </form>

      <div>
        <h3>Saved items</h3>
        {loading ? (
          <div>Loading…</div>
        ) : list.length === 0 ? (
          <div>No items yet.</div>
        ) : (
          <ul>
            {list.map((r) => (
              <li key={r.id}>
                <strong>{r.text}</strong> <small>({new Date(r.created_at).toLocaleString()})</small>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default App;
